var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_14967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4377 2.42144C16.1623 2.24997 14.4161 2.24999 12.3431 2.25C10.27 2.24999 8.63768 2.24998 7.36233 2.42144C6.05375 2.59738 5.00927 2.9661 4.18768 3.78769C3.36609 4.60928 2.99736 5.65376 2.82143 6.96234C2.64996 8.23769 2.64998 9.98391 2.64999 12.0569C2.64998 14.13 2.64997 15.7623 2.82143 17.0377C2.99737 18.3462 3.36609 19.3907 4.18768 20.2123C5.00927 21.0339 6.05375 21.4026 7.36233 21.5786C8.63768 21.75 10.3839 21.75 12.4569 21.75C14.53 21.75 16.1623 21.75 17.4377 21.5786C18.7462 21.4026 19.7907 21.0339 20.6123 20.2123C21.4339 19.3907 21.8026 18.3462 21.9786 17.0377C22.15 15.7623 22.15 14.13 22.15 12.0569C22.15 9.9839 22.15 8.23769 21.9786 6.96234C21.8026 5.65376 21.4339 4.60928 20.6123 3.78769C19.7907 2.9661 18.7462 2.59737 17.4377 2.42144ZM11.8363 7.64888C11.6967 7.27647 11.3496 7.02223 10.9524 7.00138C10.5552 6.98054 10.1834 7.19705 10.0056 7.55279L8.28196 11H6.39999C5.84771 11 5.39999 11.4477 5.39999 12C5.39999 12.5523 5.84771 13 6.39999 13H8.89999C9.27876 13 9.62503 12.786 9.79442 12.4472L10.7689 10.4983L12.9637 16.3511C13.1033 16.7235 13.4504 16.9778 13.8476 16.9986C14.2448 17.0195 14.6166 16.803 14.7944 16.4472L16.518 13H18.4C18.9523 13 19.4 12.5523 19.4 12C19.4 11.4477 18.9523 11 18.4 11H15.9C15.5212 11 15.175 11.214 15.0056 11.5528L14.0311 13.5017L11.8363 7.64888Z",
    fill: "#6929E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_14967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.399994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIc);
export default __webpack_public_path__ + "static/media/active_ic.19a68b5f31dc8f45966fae61935ccb0b.svg";
export { ForwardRef as ReactComponent };